import React from "react";
import { education, certifications } from "../data/portfolio";
import "./scss/Education.scss";

const Education: React.FC = () => {
  return (
    <section id="education" className="education">
      <div className="container">
        <h2 className="section-title">Education</h2>

        <div className="education-grid">
          {education.map((edu) => (
            <div key={edu.id} className="education-card">
              <div className="education-icon">
                <i className={edu.icon}></i>
              </div>
              <div className="education-content">
                <h3>{edu.degree}</h3>
                <h4>{edu.institution}</h4>
                <span className="education-date">{edu.duration}</span>
                <p>{edu.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="certifications">
          <h3>Professional Courses</h3>
          <div className="cert-grid">
            {certifications.map((cert) => (
              <div key={cert.id} className="cert-item">
                <div className="flex">
                  <h4>{cert.name}</h4>
                  {cert.isCertified ? (
                    <span className="cert-badge" title="Certified">
                      <i
                        className="fa-regular fa-id-badge"
                        style={{ color: "green" }}
                      ></i>
                    </span>
                  ):(<i className="fa-solid fa-book"></i>)}
                  
                </div>
                <p>{cert.issuer}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
